<!--for auto rollover sucess alert-->
@if (showBanner) {
  <div class="autorollover_Sucess">
    <div class="col-lg-12 sucess_Alert">
      <span class="sucess_Text">{{cmsContent.content}}</span>
      <span class="alert_Dismiss" (click)="dismissBanner()">x</span>
    </div>
  </div>
}
